import type { AuditEventType } from './types';
import { appendAuditEvent, generateId } from './store';
import { getDeviceFingerprint } from './fingerprint';

export async function buildAuditBase(userId?: string) {
  const fp = await getDeviceFingerprint();
  let ip: string | undefined;
  try {
    const res = await fetch('https://api.ipify.org?format=json', { signal: AbortSignal.timeout(4000) });
    const json = await res.json() as { ip?: string };
    ip = json.ip;
  } catch {
    // optional
  }
  return {
    userId,
    ip,
    deviceFingerprint: fp.fingerprint,
    userAgent: fp.userAgent,
    meta: { platform: fp.platform },
  };
}

export async function logAuditEvent(
  type: AuditEventType,
  extra: Partial<{
    userId: string;
    chatId: string;
    messageId: number;
    detail: string;
    meta: Record<string, string | number | boolean | undefined>;
  }> = {},
): Promise<void> {
  const base = await buildAuditBase(extra.userId);
  await appendAuditEvent({
    id: generateId('audit'),
    type,
    at: Date.now(),
    ...base,
    chatId: extra.chatId,
    messageId: extra.messageId,
    detail: extra.detail,
    meta: extra.meta,
  });
}
